<template>
  <div>

    <Row :gutter="16">

      <Col span="24">
        <Card dis-hover bordered>
          <!-- <pageTable ref="table"
              
                     :searchData="oilRangeForm"
                     :tableTitle="companyOilRangeColumn"
                       :currentPageSize="10"
                     tableApi="admin/finance/stationData"
          > -->

                  <pageTable ref="table"
               :tableTitle="companyOilRangeColumn"
               :searchData="oilRangeForm"
                :currentPageSize="10"
               tableApi="admin/finance/stationData"
    >

            <template v-slot:searchFormItem>
       <FormItem prop="key">
          <Input type="text" v-model="oilRangeForm.key" placeholder="Key" class="lx-search-item"></Input>
        </FormItem>
              
         <FormItem prop="platform">
          <Select v-model="oilRangeForm.platform" placeholder="渠道" clearable>
            <Option v-for="(item,key) in platform" :value="item.id" :key="key">{{item.name}}</Option>
          </Select>
        </FormItem> 

           <FormItem  prop="is_bill">
            <Select v-model="oilRangeForm.is_bill" placeholder="A型/B型" :filterable="true">
               <Option  value="6" on-change>全部</Option>
             <Option  value="2" on-change>B型</Option>
              <Option  value="1" >A型</Option>
           </Select>
          </FormItem>

          <FormItem prop="salesman">
          <Input type="text" v-model="oilRangeForm.salesman" placeholder="业务员" class="lx-search-item"></Input>
        </FormItem>

         <FormItem  prop="litre_num">
            <Select v-model="oilRangeForm.litre_num" placeholder="加油数量" :filterable="true">
               <Option  value="0" on-change>全部</Option>
              <Option  value="1" >大于0</Option>
           </Select>
          </FormItem>

        <FormItem  prop="balance">
            <Select v-model="oilRangeForm.balance" placeholder="初始金额" :filterable="true">
               <Option  value="0" on-change>全部</Option>
              <Option  value="1" >大于0</Option>
           </Select>
          </FormItem>
<!-- 
           <FormItem  prop="balance">
            <Select v-model="oilRangeForm.end_type" placeholder="期末余额" :filterable="true">
               <Option  value="1" on-change>不等于0</Option>
              <Option  value="0" >全部</Option>
           </Select>
          </FormItem>
     -->

             <FormItem prop="searchDay">
          <DatePicker v-model="oilRangeForm.searchDay" type="datetimerange" @on-change="timeChange"  placeholder="时间" style="width: 320px"></DatePicker>
        </FormItem>
  
            </template>
            <template v-slot:otherBtn>
              <FormItem>
                <Button type="info" @click="exportDetail">导出明细</Button>
              </FormItem>
            </template>
          </pageTable>
     

              <!--   记录-->
    <Drawer :title="financialRecordsModal.name" width="1400"
            :value="financialRecordsModal.isShow"
            :mask-closable="true"
            @on-close="financialRecordsModal.isShow=false" >
      <FinancialRecords  :station_id="financialRecordsModal.station_id" :dataForm="oilRangeForm"   v-if="financialRecordsModal.isShow"></FinancialRecords>
    </Drawer>
        </Card>
      </Col>
    </Row>

  </div>


</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import FinancialRecords from "./financialRecords";
  import XLSX from 'xlsx'
  export default {
    name: "home",
    components:{pageTable,FinancialRecords},
    data(){
      return {
        companyOilRangeColumn:[
           {title: '站点id',key: 'station_id',align: "left"},
          {title: '站点名称',key: 'name',align: "left",render:(h,params)=>{
              return h('div',[
                h('span',params.row.gas_name),
                h('Tag',{props:{color:'orange'}},params.row.platform),
              ])
            }},
          {title: '业务类型',key: 'station_name',align: "left",render:(h,params)=>{
            if (params.row.company_name==='汇总'){
              return h('span','')
            }else{
              return h('span',params.row.is_bill  ? 'A型' : 'B型')
            }
            }},
          {title: '业务员',key: 'salesman',align: "left"},
          {title: '加油数量',key: 'litre_num',align: "left"},
          {title: '初始金额',key: 'balance',align: "left"},
          {title: '成本A',key: 'bill_price',align: "left"},
          {title: '成本B',key: 'no_bill_price',align: "left"},
          // {title: '销售金额',key: 'company_price',align: "left"},
           {title: '充值金额',key: 'recharge_amount',align: "left"},
          {title: '返利金额',key: 'rebate_amount',align: "left"},
            {title: '期末余额',key: 'end_amount',align: "left"},
    
                     {title: '记录',align: "center",render:(h,params)=>{
              return h('div',[
                h('Button',
                  {
                    props: {type:'primary',size:'small'},
                    on:{
                      click:()=>{this.showStation(params.row)}
                    },
                  },'查看')
              ])
            }},

        ],
        oilRangeForm:{
          searchDay:'',
          key:'',
          platform:'',
          is_bill:'6',
          key:'',
          salesman:'',
          litre_num:'',
          balance:'',
          end_type:'1'
      
        },
         financialRecordsModal:{
          isShow:false,
          station_id:'',
          type:'',
          name:'',
          dataForm:'',
        },
      }
    },
    methods:{
        async initPage(){
        let res = await this.$commonFun.postProxy('admin/common/getPageInitInfo',{type:['platform']});
        this.platform = res.data.platform
    
        // alert(platform)
        // let res2 = await this.$commonFun.postProxy('admin/gas/getAllProvinceData',{});
        // this.provinceData = res2.data
      },
           showStation(info){
        this.financialRecordsModal.isShow = true
        this.financialRecordsModal.station_id =info.station_id
        this.financialRecordsModal.name ='详情'
         this.financialRecordsModal.dataForm =this.oilRangeForm
        
      },
            exportDetail(){
        this.$commonFun.postProxy('admin/finance/exportFinanceCount',this.oilRangeForm).then((res)=>{
          let worksheet = XLSX.utils.aoa_to_sheet(res.data)
          let workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
          XLSX.writeFile(workbook,`站点财务统计.xlsx`)
        })
      },
          timeChange(time) {
        if(time[1].slice(-8)==='00:00:00'){
          time[1] = time[1].slice(0,-8) + '23:59:59'
          this.oilRangeForm.searchDay = time
        }
      },
      
    },
    mounted(){
   this.initPage()
    },
    created() {
   
    }
  }
</script>

<style scoped>

</style>
